export interface RtuLicenseOptions {
  opcUaServer: boolean;
  tcpDnp3Slave: boolean;
  isagraf: boolean;
  esp: boolean;
  timerController: boolean;
  poc: boolean;
}

export const initialRtuLicenseOptions: RtuLicenseOptions = {
  opcUaServer: false,
  tcpDnp3Slave: false,
  isagraf: false,
  esp: false,
  timerController: false,
  poc: false,
};

export const RTU_LICENSE_MODULE_FIELDS: Array<{
  key: keyof RtuLicenseOptions;
  labelKey: string;
}> = [
  { key: 'opcUaServer', labelKey: 'rtuActions.license.modules.opcUaServer' },
  { key: 'tcpDnp3Slave', labelKey: 'rtuActions.license.modules.tcpDnp3Slave' },
  { key: 'isagraf', labelKey: 'rtuActions.license.modules.isagraf' },
  { key: 'esp', labelKey: 'rtuActions.license.modules.esp' },
  { key: 'timerController', labelKey: 'rtuActions.license.modules.timerController' },
  { key: 'poc', labelKey: 'rtuActions.license.modules.poc' },
];
